import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Récupérer l'utilisateur depuis le localStorage pour vérification discrète
  const getUserFromStorage = () => {
    try {
      const savedUser = localStorage.getItem('user');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch {
      return null;
    }
  };

  const user = getUserFromStorage();
  const canAccessAudit = user && (user.role === 'owner' || user.role === 'system_admin');

  return (
    <footer className="bg-white/90 backdrop-blur-md border-t border-gray-200 mt-auto py-8">
      <div className="max-width-container px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3">
          <p className="text-base text-gray-700 font-medium">
            © 2025 Système de Suivi de Production Boulangerie
          </p>
          <div className="text-sm text-gray-600 space-y-2">
            <p>
              Créé par <span className="font-semibold text-gray-800 text-lg">Elouho Ettien Ane Martial T.</span>
            </p>
            <p className="font-semibold text-base">
              Consultant Juriste-Fiscaliste & Financier
            </p>
            <p className="font-mono bg-gradient-to-r from-blue-100 to-indigo-100 inline-block px-4 py-2 rounded-lg text-base">
              📞 Tél: +225 07 69 54 54 69
            </p>
            
            {/* Accès discret à l'audit pour les autorisés */}
            {canAccessAudit && (
              <p className="text-xs text-gray-400 mt-4">
                <Link 
                  to="/system/audit-trail-secret"
                  className="hover:text-red-500 transition-colors"
                  title="Journal d'audit système"
                >
                  •
                </Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;